import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punwetosuratccab() {



    const cardData = {

keyword: "Pune to Surat Cab",

headingDescription:
    "Rising Cab Service offers reliable and comfortable Pune to Surat Cab services for families, business travelers, tourists, and corporate clients. We provide Sedan, SUV, Innova Crysta, Tempo Traveller, and luxury vehicles for one-way and round-trip travel with experienced chauffeurs. Our service includes doorstep pickup, 24/7 booking support, transparent pricing, and well-maintained cabs, ensuring a safe and hassle-free journey from Pune to Surat for business, leisure, and family trips.",

topPlaces: [
    {
        title: "Dumas Beach",
        description:
            "Dumas Beach is one of the most famous tourist attractions near Surat, known for its unique black sand and scenic Arabian Sea coastline. Visitors enjoy long walks, local street food, beautiful sunsets, and the refreshing sea breeze. The beach is especially popular during weekends and evenings when families and tourists gather to relax. Its natural beauty and peaceful atmosphere make it one of the must-visit destinations in Surat."
    },
    {
        title: "Sarthana Nature Park and Zoo",
        description:
            "Sarthana Nature Park is a popular wildlife and recreational destination spread across a large green area in Surat. The park houses various species of animals, birds, and reptiles while offering beautiful gardens and walking paths. Families with children often visit to enjoy nature and educational exhibits. It serves as an ideal location for picnics and outdoor activities."
    },
    {
        title: "Ambika Niketan Temple",
        description:
            "Ambika Niketan Temple is a revered Hindu temple dedicated to Goddess Ambika and is located on the banks of the Tapi River. The temple attracts thousands of devotees throughout the year who come to seek blessings and participate in religious festivals. Its peaceful surroundings and beautiful architecture make it a significant spiritual landmark in Surat."
    },
    {
        title: "Dutch Garden",
        description:
            "Dutch Garden is a historical site featuring well-maintained gardens and ancient European-style tombs built during the Dutch colonial period. The beautifully landscaped surroundings and historical monuments attract history enthusiasts and tourists looking for a peaceful place to explore. The garden reflects Surat's rich maritime and trading history."
    },
    {
        title: "Science Centre Surat",
        description:
            "The Science Centre in Surat is a modern educational attraction featuring interactive science exhibits, a planetarium, an art gallery, and an amphitheater. It provides engaging experiences for students, families, and visitors interested in science and technology. The center regularly hosts educational programs and exhibitions."
    },
    {
        title: "Gopi Talav",
        description:
            "Gopi Talav is a beautifully redeveloped lake and recreational area that combines history with modern entertainment. Visitors can enjoy boating, landscaped gardens, food courts, and cultural events. The lake was originally built centuries ago and has become one of Surat's favorite family outing destinations."
    },
    {
        title: "Surat Castle",
        description:
            "Surat Castle is a historic fort constructed in the 16th century to protect the city from invasions. The fort showcases impressive architecture and offers insights into Surat's importance as a major trading port during ancient and medieval times. It remains a key heritage attraction for history lovers."
    },
    {
        title: "VR Surat Mall",
        description:
            "VR Surat is one of the city's premier shopping and entertainment destinations, featuring international brands, multiplex cinemas, restaurants, and family entertainment zones. It offers a modern lifestyle experience and attracts both locals and tourists throughout the year."
    },
    {
        title: "Suvali Beach",
        description:
            "Suvali Beach is a peaceful coastal destination near Surat known for its clean shoreline and less crowded atmosphere. Visitors enjoy picnics, photography, and beautiful sunset views over the Arabian Sea. The beach provides a relaxing escape from the city's busy life."
    },
    {
        title: "Tapi River Front",
        description:
            "The Tapi River Front is a scenic riverside development where visitors can enjoy walking, cycling, and relaxing while admiring the beautiful views of the Tapi River. The well-maintained pathways and landscaped areas make it a popular attraction for families, fitness enthusiasts, and tourists exploring Surat."
    }
],



services: [
{
    name: "Pune to Surat Cab",
    description: "Rising Cab Service offers Pune to Surat Cab with safe, comfortable, and affordable outstation travel for families, business travelers, tourists, and corporate clients. We provide one-way and round-trip cab services with experienced drivers, clean AC vehicles, transparent pricing, and 24x7 booking support. Choose from Sedan, SUV, Ertiga, Innova, Innova Crysta, and Kia Carens for a smooth highway journey between Pune and Surat with convenient doorstep pickup and drop facilities."
},
{
    name: "Pune to Surat Cab Service",
    description: "Book Pune to Surat Cab Service with Rising Cab Service for reliable intercity transportation. Our well-maintained vehicles, professional chauffeurs, and flexible travel plans make every journey comfortable, safe, and hassle-free for personal and business travel."
},
{
    name: "Pune to Surat Taxi Service",
    description: "Our Pune to Surat Taxi Service provides dependable long-distance travel with affordable fares, clean AC cabs, and experienced drivers. We offer customized travel solutions for families, corporate clients, and tourists."
},
{
    name: "Pune to Surat Cab Booking",
    description: "Rising Cab Service provides easy Pune to Surat Cab Booking with instant confirmation, multiple vehicle options, and transparent pricing for one-way and round-trip travel."
},
{
    name: "Best Pune to Surat Cab",
    description: "Best Pune to Surat Cab offers premium travel comfort with professional drivers, spacious vehicles, and dependable customer service for safe and enjoyable long-distance journeys."
},
{
    name: "One Way Pune to Surat Cab",
    description: "One Way Pune to Surat Cab is ideal for passengers looking for economical single-trip transportation with comfortable AC vehicles and professional drivers."
},
{
    name: "Round Trip Pune to Surat Taxi",
    description: "Book Round Trip Pune to Surat Taxi with flexible return options, waiting facilities, and affordable pricing for business trips, family vacations, and tourism."
},
{
    name: "Cheap Pune to Surat Cab",
    description: "Cheap Pune to Surat Cab offers budget-friendly outstation travel while maintaining high standards of comfort, safety, and service quality."
},
{
    name: "24x7 Pune to Surat Cab Service",
    description: "Rising Cab Service provides 24x7 Pune to Surat Cab Service with round-the-clock availability, instant booking assistance, and reliable transportation."
},
{
    name: "Outstation Cab Pune to Surat",
    description: "Outstation Cab Pune to Surat ensures comfortable highway travel with AC vehicles, experienced drivers, and flexible travel schedules."
},
{
    name: "Pune to Vadodara Cab",
    description: "Book Pune to Vadodara Cab for safe and comfortable intercity travel with one-way and round-trip options, experienced chauffeurs, and affordable pricing."
},
{
    name: "Pune to Vadodara Cab Service",
    description: "Pune to Vadodara Cab Service provides reliable long-distance transportation with clean vehicles, professional drivers, and convenient booking options."
},
{
    name: "Pune to Vadodara Taxi Service",
    description: "Our Pune to Vadodara Taxi Service offers smooth and affordable travel for family trips, business journeys, and holiday tours."
},
{
    name: "Pune to Vadodara Cab Booking",
    description: "Rising Cab Service provides Pune to Vadodara Cab Booking with quick confirmation, multiple cab choices, and dependable customer support."
},
{
    name: "Best Pune to Vadodara Cab",
    description: "Best Pune to Vadodara Cab combines premium comfort, experienced drivers, and quality service for safe and pleasant travel."
},
{
    name: "One Way Pune to Vadodara Cab",
    description: "One Way Pune to Vadodara Cab offers affordable single-trip transportation with comfortable vehicles and transparent fares."
},
{
    name: "Round Trip Pune to Vadodara Taxi",
    description: "Round Trip Pune to Vadodara Taxi includes flexible return schedules and comfortable travel arrangements for families and business travelers."
},
{
    name: "Cheap Pune to Vadodara Cab",
    description: "Cheap Pune to Vadodara Cab provides economical travel solutions with safe driving and comfortable vehicles."
},
{
    name: "Outstation Cab Pune to Vadodara",
    description: "Outstation Cab Pune to Vadodara offers reliable highway travel with experienced drivers and well-maintained AC vehicles."
},
{
    name: "Pune to Surat Innova Crysta Cab",
    description: "Pune to Surat Innova Crysta Cab is perfect for family and group travel with luxury seating, spacious interiors, and premium comfort."
},
{
    name: "Innova Crysta Pune to Surat",
    description: "Innova Crysta Pune to Surat provides premium outstation transportation with professional chauffeurs and comfortable long-distance travel."
},
{
    name: "Luxury Innova Cab Pune Surat",
    description: "Luxury Innova Cab Pune Surat offers high-end travel experiences with spacious seating, modern amenities, and smooth highway journeys."
},
{
    name: "AC Innova Crysta Pune Surat",
    description: "AC Innova Crysta Pune Surat ensures cool, comfortable, and luxurious travel for families, corporate clients, and tourists."
},
{
    name: "Pune Surat SUV Taxi Service",
    description: "Pune Surat SUV Taxi Service is ideal for larger families and groups needing extra luggage space and comfortable long-distance transportation."
},
{
    name: "Pune to Surat Ertiga Cab",
    description: "Pune to Surat Ertiga Cab offers economical group travel with spacious seating and reliable service for long-distance journeys."
},
{
    name: "Ertiga Cab Pune Surat",
    description: "Ertiga Cab Pune Surat provides comfortable and affordable travel with professional drivers and well-maintained vehicles."
},
{
    name: "Pune to Surat Kia Carens Cab",
    description: "Pune to Surat Kia Carens Cab offers premium family travel with modern features, spacious interiors, and a comfortable journey experience."
}
],

tableData: [
["Pune to Surat Cab","Pune to Surat Cab Service"],
["Pune to Surat Taxi Service","Pune to Surat Cab Booking"],
["Best Pune to Surat Cab","One Way Pune to Surat Cab"],
["Round Trip Pune to Surat Taxi","Cheap Pune to Surat Cab"],
["24x7 Pune to Surat Cab Service","Outstation Cab Pune to Surat"],
["Pune to Vadodara Cab","Pune to Vadodara Cab Service"],
["Pune to Vadodara Taxi Service","Pune to Vadodara Cab Booking"],
["Best Pune to Vadodara Cab","One Way Pune to Vadodara Cab"],
["Round Trip Pune to Vadodara Taxi","Cheap Pune to Vadodara Cab"],
["Outstation Cab Pune to Vadodara","Pune to Surat Innova Crysta Cab"],
["Innova Crysta Pune to Surat","Luxury Innova Cab Pune Surat"],
["AC Innova Crysta Pune Surat","Pune Surat SUV Taxi Service"],
["Pune to Surat Ertiga Cab","Ertiga Cab Pune Surat"],
["Pune to Surat Kia Carens Cab","Pune to Surat Cab"]
],




whychoose: [
    {
        WhyChooseheading: "Reliable Pune to Surat Cab Service",
        WhyChoosedescription: "Rising Cab Service offers dependable Pune to Surat cab transportation for business travelers, families, tourists, students, and corporate professionals."
    },
    {
        WhyChooseheading: "Convenient Interstate Travel Experience",
        WhyChoosedescription: "Travel comfortably between Maharashtra and Gujarat with professionally managed cab services designed for long-distance journeys."
    },
    {
        WhyChooseheading: "Perfect for Business and Commercial Visits",
        WhyChoosedescription: "Surat is a major textile, diamond, and commercial hub, making our cab service a preferred choice for entrepreneurs, traders, and corporate travelers."
    },
    {
        WhyChooseheading: "Comfortable Vehicles for Every Journey",
        WhyChoosedescription: "Customers can choose Sedan cars, Ertiga, Innova Crysta, SUVs, Tempo Travellers, and premium vehicles according to their travel requirements."
    },
    {
        WhyChooseheading: "Flexible One-Way and Round Trip Packages",
        WhyChoosedescription: "We provide one-way transfers, return journeys, multi-day travel plans, and customized cab packages for personal and business travel."
    },
    {
        WhyChooseheading: "Doorstep Pickup Across Pune & PCMC",
        WhyChoosedescription: "Pickup facilities are available from Baner, Wakad, Hinjewadi, Kharadi, Hadapsar, Viman Nagar, Kothrud, Wagholi, Pimpri Chinchwad, and surrounding locations."
    },
    {
        WhyChooseheading: "Safe Travel with Experienced Drivers",
        WhyChoosedescription: "Our professional drivers are familiar with interstate highways and ensure smooth, secure, and comfortable transportation throughout the journey."
    },
    {
        WhyChooseheading: "Customized Travel Plans Available",
        WhyChoosedescription: "Passengers can include sightseeing locations, business meetings, family visits, meal breaks, and overnight stops according to their itinerary."
    }
]
};

const faqData = [
    {
        question: "Why do travelers frequently visit Surat from Pune?",
        answer: "Surat is known for its diamond industry, textile market, business opportunities, educational institutions, and tourist attractions."
    },
    {
        question: "Can I book a one-way cab from Pune to Surat?",
        answer: "Yes, one-way taxi services are available along with round-trip and customized travel packages."
    },
    {
        question: "Which vehicle is suitable for Pune to Surat travel?",
        answer: "Ertiga, Innova Crysta, SUVs, and Sedan cars are commonly preferred for comfortable long-distance travel."
    },
    {
        question: "Do business travelers regularly use this service?",
        answer: "Yes, many professionals and business owners travel between Pune and Surat for meetings, exhibitions, and commercial activities."
    },
    {
        question: "Can families hire cabs for vacations and personal visits?",
        answer: "Yes, families frequently use our Pune to Surat cab service for holidays, family gatherings, and social events."
    },
    {
        question: "Are Tempo Travellers available for group travel?",
        answer: "Yes, Tempo Travellers and larger vehicles can be arranged for group tours, corporate teams, and family trips."
    },
    {
        question: "Can multiple destinations be included during the journey?",
        answer: "Yes, customized itineraries can include destinations such as Nashik, Saputara, Vadodara, Ahmedabad, and other nearby locations."
    },
    {
        question: "Can passengers begin the trip from Pune Airport or Railway Station?",
        answer: "Yes, pickups are available from Pune Airport, Railway Station, hotels, offices, and residential locations."
    },
    {
        question: "Is advance booking recommended for Pune to Surat travel?",
        answer: "Yes, advance reservations help secure preferred vehicle options and ensure smooth travel planning."
    },
    {
        question: "How can I reserve a Pune to Surat Cab?",
        answer: "Bookings can be confirmed through phone calls, WhatsApp messages, or online inquiries with Rising Cab Service."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Deepak Shah",
        feedback:
            "My business trip to Surat was handled exceptionally well. The vehicle was comfortable, the driver was professional, and the entire journey was completed smoothly.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Priyanka Mehta",
        feedback:
            "We traveled from Pune to Surat for a family function and had a wonderful experience. The cab was spacious, clean, and made the long journey very comfortable.",
        rating: 5
    }
];

    const Images = [
        { place: "/images/keyword/1.jpg", text: "Pune Darshan Cab", link: "Pune-Darshan-Cab" },
        { place: "/images/keyword/2.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
        { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad to Bhimashankar Cab", link: "Pimpri-Chinchwad-to-Bhimashankar-Cab" },
        { place: "/images/keyword/4.jpg", text: "Pune to Jejuri Cab", link: "Pune-to-Jejuri-Cab" },
        { place: "/images/keyword/5.jpg", text: "Pune Weekend Tour Packages", link: "Pune-Weekend-Tour-Packages" },
        { place: "/images/keyword/6.jpg", text: "Pune Darshan Packages", link: "Pune-Darshan-Packages" },
        { place: "/images/keyword/7.jpg", text: "Pune Sade Teen Shakti Peeth Bus on Rent", link: "Pune-Sade-Teen-Shakti-Peeth-Bus-on-Rent" },
        { place: "/images/keyword/8.jpg", text: "Pune Darshan Tempo Traveller on Rent", link: "Pune-Darshan-Tempo-Traveller-on-Rent" },
        { place: "/images/keyword/9.jpg", text: "Pune to Mysore Ooty Cab Package", link: "Pune-to-Mysore-Ooty-Cab-Package" },
        { place: "/images/keyword/10.jpg", text: "Pune to Mumbai Darshan Package", link: "Pune-to-Mumbai-Darshan-Package" },
        { place: "/images/keyword/11.jpg", text: "Pune to Ajanta Ellora Cab Service", link: "Pune-to-Ajanta-Ellora-Cab-Service" },
        { place: "/images/keyword/12.jpg", text: "Pune to Shirdi Darshan Package", link: "Pune-to-Shirdi-Darshan-Package" },
        { place: "/images/keyword/13.jpg", text: "Pune to Pandharpur Darshan", link: "Pune-to-Pandharpur-Darshan" },
        { place: "/images/keyword/14.jpg", text: "Hinjewadi Cab Service", link: "Hinjewadi-Cab-Service" },
        { place: "/images/keyword/15.jpg", text: "Cab Service in Wakad", link: "Cab-Service-in-Wakad" },
        { place: "/images/keyword/16.jpg", text: "Cab Service in Baner Pune", link: "Cab-Service-in-Baner-Pune" },
        { place: "/images/keyword/17.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
        { place: "/images/keyword/18.jpg", text: "Cab Service in Hadapsar", link: "Cab-Service-in-Hadapsar" },
        { place: "/images/keyword/19.jpg", text: "Cab Service in Viman Nagar", link: "Cab-Service-in-Viman-Nagar" },
        { place: "/images/keyword/20.jpg", text: "Cab Service in Kothrud", link: "Cab-Service-in-Kothrud" },
        { place: "/images/keyword/21.jpg", text: "Cab Service in Pimpri Chinchwad", link: "Cab-Service-in-Pimpri-Chinchwad" },
        { place: "/images/keyword/22.jpg", text: "Cab Service in Wagholi Pune", link: "Cab-Service-in-Wagholi-Pune" },
        { place: "/images/keyword/23.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
        { place: "/images/keyword/24.jpg", text: "Cab Service in Pune", link: "Cab-Service-in-Pune" },
        { place: "/images/keyword/25.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    ];













const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pune to Surat Cab Service",
"image": "https://www.risingcabservice.com/assets/images/pune-to-surat-cab.jpg",
"description": "Book Pune to Surat Cab Service with Rising Cab Service for safe, comfortable, and long-distance travel. Enjoy reliable one-way and round-trip taxi service with AC sedans, SUVs, and Innova cars at affordable prices.",
"brand": {
"@type": "Brand",
"name": "Rising Cab Service"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "5471"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹14/Km",
"availability": "https://schema.org/InStock",
"url": "https://www.risingcabservice.com/pune-to-surat-cab"
}
};


    return (
        <div>


<Helmet>
  <title>Pune to Surat Cab | Long Distance Taxi | +91 9272511548</title>

<meta
 name="description"
 content="Book Pune to Surat Cab Service for safe and comfortable long-distance travel. Get reliable one-way and round-trip taxi service with AC sedans, SUVs, and Innova cars at best prices."
/>

<meta
 name="keywords"
 content="pune to surat cab, pune to surat taxi, cab from pune to surat, taxi from pune to surat, pune to surat cab service, pune to surat taxi fare, pune to surat one way cab, pune to surat round trip taxi, pune to surat cab booking, cheap pune to surat cab, best pune to surat taxi, sedan pune to surat cab, suv pune to surat taxi, innova pune to surat cab, long distance cab pune surat, Pune to Surat Cab, Pune to Surat Cab Service, Pune to Surat Taxi Service"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>




            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('./img/bg/breadcrumb-bg.jpg')",
                    position: "relative",
                }}
            >
                <div
                    style={{
                        position: "absolute",
                        inset: 0,
                        backgroundColor: "rgba(0,0,0,0.3)",
                        zIndex: 1,
                    }}></div>

                <div className="container" style={{ position: "relative", zIndex: 2 }}>
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title"> {cardData.keyword}</h1>
                    </div>
                </div>
            </div>




















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/51.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#FF681A', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Rising Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Rising Cab Service</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Rising Cab Service </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title="Frequently Asked"
                                                    subtitle="Help & Info"
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919272511548" className="pc-call">+91 9272511548</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919272511548"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919272511548" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@risingcabservice.com" className="pc-email">
                                            booking@risingcabservice.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Rising Cab Service</strong><br />

                                            A Unit of Atithya Dining LLP,
                                            901, 902 Deron Height, Baner Rd,
                                            Above Ranka Jewelers, Pune,
                                            Maharashtra -411069
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punwetosuratccab;